"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.DynamicFeatureLoader = void 0;
exports.DynamicFeatureLoader = Symbol('DynamicFeatureLoader');
//# sourceMappingURL=dynamicLoader.js.map